import { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when the retailer is bucketed in the OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312 XP
 */
export const HAS_SEEN_OWF_APPLICATION_FUNNEL_OPTIMIZATIONS =
  'HAS_SEEN_OWF_APPLICATION_FUNNEL_OPTIMIZATIONS' as IUserMilestone.RetailerMilestone;
